import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Uninstall a knowledge base
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDeleteInstalledKnowledge = packet => {
  return {
    type: 'REQUEST_DELETE_INSTALLED_KNOWLEDGE',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveDeleteInstalledKnowledgeSuccess = data => ({
  type: 'RECEIVE_DELETE_INSTALLED_KNOWLEDGE_SUCCESS',
  data
})

export const receiveDeleteInstalledKnowledgeFail = data => ({
  type: 'RECEIVE_DELETE_INSTALLED_KNOWLEDGE_FAIL',
  data
})

export const tryToDeleteInstalledKnowledge = packet => (dispatch, getState) => {

  dispatch(requestDeleteInstalledKnowledge(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = Cookies.get(process.env.REACT_APP_COOKIE_FEATURE_SWITCH)
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/projects/installed-knowledge/' + packet.id + '/' + packet.knowledge_id, {
      method: 'delete',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveDeleteInstalledKnowledgeSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveDeleteInstalledKnowledgeFail({errors:e, lastSubmit: packet}));
    })
}
